module.exports = __webpack_public_path__ + "85c08e8d57abc0f03fc2a9a8be7c5c97.pdf";